export default __webpack_public_path__ + "static/media/char_side.928692d5.png";